import type { Locale } from "../../i18n/dictionary";
import { getDictionary } from "../../i18n/dictionary";
import "../../components/portal.css";

function IconPersonQuestion() {
  return (
    <svg viewBox="0 0 24 24" width="38" height="38" fill="none" stroke="var(--peach-deep)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3.2" /><path d="M4 20a6 6 0 0110 0" /><path d="M17 9v4M17 16h.01" />
    </svg>
  );
}

// ---- AdminNotOrg ------------------------------------------------------------

export interface AdminNotOrgProps {
  locale: Locale;
  onBack: () => void;
}

/**
 * "This email isn't part of an organisation yet" screen (admin portal).
 * Warm peach icon and background — never red (05_PORTAL_DESIGN.md §3, §4).
 */
export function AdminNotOrg({ locale, onBack }: AdminNotOrgProps) {
  const dict = getDictionary(locale);
  const t = dict.admin.signIn;
  return (
    <div
      className="zp-root"
      style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 32, position: "relative", overflow: "hidden", fontFamily: "var(--font-body)", background: "var(--bg)", color: "var(--ink)" }}
    >
      {/* Warm peach blob — never red */}
      <div style={{ position: "absolute", top: -160, insetInlineEnd: -120, width: 520, height: 520, borderRadius: "50%", background: "radial-gradient(circle, var(--peach-tint), transparent 70%)", filter: "blur(8px)", pointerEvents: "none" }} />

      <div style={{ position: "relative", width: "100%", maxWidth: 460, textAlign: "center" }}>
        {/* Warm peach icon well — never red */}
        <div
          style={{ width: 88, height: 88, borderRadius: "var(--r-lg)", background: "var(--peach-tint)", display: "grid", placeItems: "center", margin: "0 auto 22px" }}
          role="img"
          aria-label="Notice"
        >
          <IconPersonQuestion />
        </div>
        <h1 style={{ fontSize: 26, color: "var(--ink-deep)", margin: 0 }}>{t.notMemberTitle}</h1>
        <p style={{ color: "var(--ink-soft)", marginTop: 12, fontSize: 16, lineHeight: 1.65, margin: "12px 0 0" }}>
          Ask your organisation admin to invite you. Admins can manage seats from the Members screen.
        </p>

        <button
          onClick={onBack}
          style={{ marginTop: 24, minHeight: 52, padding: "0 28px", border: "2px solid var(--line-strong)", background: "transparent", color: "var(--ink)", borderRadius: "var(--r-pill)", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: 16, cursor: "pointer" }}
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}
